import { Component, ViewEncapsulation, inject, signal } from '@angular/core';
import { IrisMainMenuService } from '@iris/common/services/main-menu.service';
import { IrisMenuItemI } from '@iris/common/models/IrisMenuItem';
import cloneDeep from 'lodash/cloneDeep';
import { TranslateService } from '@ngx-translate/core';
import { tap } from 'rxjs/operators';
import { AppAliasUrlSerializer } from '@iris/common/services/app-alias-url-serializer';
import { IrisModules } from '@iris/common/models/IrisModulesEnums';
import { IrisSecurityService } from '@iris/common/modules/security/services/security.service';

@Component({
  selector: 'iris-header-settings',
  templateUrl: './header-settings.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class IrisHeaderSettingsComponent {
  private readonly mainMenuService = inject(IrisMainMenuService);
  private readonly urlSerializer = inject(AppAliasUrlSerializer);
  private readonly translate = inject(TranslateService);
  private readonly securityService = inject(IrisSecurityService);

  private readonly canConfigSystemSettings = this.securityService.hasPermissions(IrisModules.SYSTEMCONFIG, 'Module', 'config');
  private readonly canAccessSystemSettings = this.securityService.hasPermissions(IrisModules.SYSTEMCONFIG, 'Module', 'access');
  readonly hasAccess = signal(this.canConfigSystemSettings || this.canAccessSystemSettings);

  menu: IrisMenuItemI[] = [];

  constructor() {
    this.mainMenuService.getConfigMenu().pipe(
      tap(configMenu => {
        const treeMenu: IrisMenuItemI[] = this.mainMenuService.prepareMenuFromData(cloneDeep(configMenu));
        this.menu = this.getFlatList(treeMenu, 0);
      }),
    ).subscribe();
  }

  getUi2SubPathOrNull = (url: string): string => this.urlSerializer.getUi2SubPathOrNull(url);

  private getFlatList(menu: IrisMenuItemI[], level: number): IrisMenuItemI[] {
    if (!Array.isArray(menu) || !menu.length) {
      return [];
    }

    return menu.reduce((list, item) => {
      item.level = level;
      item.dataTestAttr = item.url != null ? item.title?.toLowerCase().split(' ').join('-') : null;

      if (item.module) {
        switch (item.module.toLowerCase()) {
          case 'systemconfig':
            item.hotkey = `${this.translate.instant('label.Ctrl')} + ,`;
            break;
          case 'admin':
            item.hotkey = `${this.translate.instant('label.Ctrl')} + .`;
            break;
        }
      }

      list.push(item);

      return list.concat(this.getFlatList(item.children, level + 1));
    }, []);
  }
}
